import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core';
import { TrueImpactChild } from 'shared/design-system/components/TrueImpactBadge';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const StyledDiv = styled.div`
  max-width: 574px;
  .completed-section-heading {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: ${SPACERS.large};
  }
  .completed-section-subheading {
    margin-left: auto;
    margin-right: auto;
  }
  .icon {
    margin-bottom: ${SPACERS.medium};
  }
  .go-to-impact-summary-button {
    display: flex;
    justify-content: center;
    margin-top: ${SPACERS.extraLarge};
  }
`;

interface IndicatorCompletedRenderProps {
  icon: IconDefinition | IconProp | undefined;
  iconColor?: keyof typeof COLORS;
  heading: string | React.ReactNode;
  subheading?: string | React.ReactNode;
  children?: TrueImpactChild;
}

const IndicatorCompletedRender: React.FC<IndicatorCompletedRenderProps> = ({
  heading,
  subheading,
  icon,
  iconColor = 'ctaPrimary',
  children,
}) => {
  return (
    <StyledDiv>
      {icon && (
        <FontAwesomeIcon
          size="4x"
          icon={icon}
          color={COLORS[iconColor]}
          className="icon"
        />
      )}
      <TrueImpactText
        variant="heading-page"
        className="completed-section-heading"
      >
        {heading}
      </TrueImpactText>
      {subheading && (
        <TrueImpactText
          variant="body-large"
          className="completed-section-subheading"
        >
          {subheading}
        </TrueImpactText>
      )}
      {children}
    </StyledDiv>
  );
};

export default IndicatorCompletedRender;
